import { Col, Input, Modal, Row, Select } from "antd";
import Title from "antd/es/typography/Title";
import { KeyResultSymbol } from "app/config/constants";
import { useAppDispatch, useAppSelector } from "app/config/store";
import { setFilterOrgCheckIn, setListFilterCopyListKr } from "app/entities/filters/filters.reducer";
import CopyKR from 'app/entities/kr/form/copy-next-year/copy-kr';
import { getEntitiesCopy } from 'app/entities/kr/kr.reducer';
import TableComponent from "app/shared/component/table/table";
import { overridePaginationStateWithQueryParams } from "app/shared/util/entity-utils";
import { DESC, ITEMS_PER_PAGE } from "app/shared/util/pagination.constants";
import { filterOption } from "app/shared/util/select-filter";
import * as _ from 'lodash';
import React, { useEffect, useState } from "react";
import { getPaginationState } from "react-jhipster";
import { useLocation } from "react-router-dom";
import { Container } from "reactstrap";
import { versionPlanPeriodYear } from '../../config';
import { columns } from './config';

const { Search } = Input;

type IOrganizationActiveCheckIn = {
    isOpen: boolean;
    onClose: () => void;
    idObjectiveSelected?: string;
}
const CopyKRComponent = ({ isOpen, onClose, idObjectiveSelected }: IOrganizationActiveCheckIn) => {
    const dispatch = useAppDispatch();
    const pageLocation = useLocation();

    const entities = useAppSelector(state => state.kr.entities);
    const isLoading = useAppSelector(state => state.checkIn.loading);
    const filters = useAppSelector(state => state.filters.copyKr);
    const filtersObjective = useAppSelector(state => state.filters.objective);

    const [paginationState, setPaginationState] = useState(
        overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
    );

    const [krBaseSelected, setKrBaseSelected] = useState(null);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [isOpenModalFormCopyKR, setOpenModalFormCopyKR] = useState(false);

    useEffect(() => {
        dispatch(
            setListFilterCopyListKr({
                ...filtersObjective,
                okrVersion: filtersObjective?.okrVersion ?? filtersObjective?.adjustPlanPeriod ?? null,
            }),
        );
    }, [filtersObjective])

    useEffect(() => {
        if (entities) {
            // Extract keys of all rows for expanding all rows
            const allRowKeys = getAllRowKeys(entities);
            setExpandedRowKeys(allRowKeys);
        }
    }, [entities]);

    useEffect(() => {
        if (filters?.planPeriodId) {
            getAllEntities();
        }
    }, [filters]);

    const getAllRowKeys = item => {
        return item.reduce((keys, value) => {
            keys.push(value.code);

            if (value.keyResults) {
                keys = keys.concat(getAllRowKeys(value.keyResults));
            }

            return keys;
        }, []);
    };


    const handleOpenModalCreateKrNextPlanPeriod = (item) => {
        setOpenModalFormCopyKR(true);
        setKrBaseSelected(item)
    }

    const handleCloseModalCreateKrNextPlanPeriod = (isReload = false) => {
        setOpenModalFormCopyKR(false);
        setKrBaseSelected(null)
        if (isReload) {
            getAllEntities();
        }
    };

    const handleRowClick = (event, record) => {
        event.preventDefault();
        if (_.startsWith(record.code, KeyResultSymbol)) {
            localStorage.setItem('scrollToRow', record.code);
            handleOpenModalCreateKrNextPlanPeriod(record)
        }
    };

    const handleChangeOkrVersion = value => {
        dispatch(
            setListFilterCopyListKr({
                ...filters,
                adjustPlanPeriod: value,
                okrVersion: value,
            }),
        );
    };

    const handleFreeTextSearchQuery = query => {
        dispatch(setFilterOrgCheckIn({ ...filters, searchText: query }));
    };

    const handleChange = (pageNumber: number, size: number, sorter: any) => {
        setPaginationState({
            ...paginationState,
            order: DESC, //sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC,
            sort: sorter.columnKey,
            activePage: pageNumber,
            itemsPerPage: size,
        });
    };

    const handleClose = () => {
        dispatch(setListFilterCopyListKr({}))
        onClose();
    }

    const getAllEntities = () => {
        dispatch(getEntitiesCopy({
            searchText: filters?.searchText,
            partyId: filters?.accountableId,
            okrVersion: filters?.okrVersion,
            planPeriodId: filters?.planPeriodId,
        }))
    }

    return (
        <Modal onCancel={() => { handleClose() }} open={isOpen} maskClosable={false} width={1300} footer={null}>
            <Container className="view">
                <div className="d-flex gap-5 mt-2">
                    <Row className="d-flex justify-content-between w-100">
                        <Col md={13}>
                            <Title level={3}>{`Chọn KR cần copy ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
                        </Col>
                    </Row>
                </div>
                <div className="table">
                    <div className="header">
                        <Col md={18}>
                            <Row className='w-100'>
                                <Col md={3}>
                                    <Input
                                        className="w-100"
                                        value={filters?.year - 1}
                                        disabled
                                    />
                                </Col>
                                <Col md={1} />
                                <Col md={5}>
                                    <Select
                                        className="w-100"
                                        value={filters?.okrVersion ?? filters?.adjustPlanPeriod}
                                        options={versionPlanPeriodYear}
                                        onChange={handleChangeOkrVersion}
                                        filterOption={filterOption}
                                        placeholder="Chọn phiên bản"
                                        size="large"
                                    />
                                </Col>
                                <Col md={1} />
                                <Col md={14}>
                                    <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                                </Col>
                            </Row>
                        </Col>
                    </div>
                </div>
                <TableComponent
                    data={entities.map((x, index) => {
                        return {
                            key: x.code,
                            ...x,
                            children: x.krs && x.krs.map(y => {
                                return {
                                    key: y.code,
                                    ...y,
                                };
                            }),
                        };
                    })}
                    scroll={true}
                    isFetching={isLoading}
                    tableLayout="fixed"
                    columns={columns}
                    noPagination={true}
                    expandIconColumnIndex={4}
                    expandedRowKeys={expandedRowKeys}
                    handleRowClick={(event, record) => { handleRowClick(event, record) }}
                    setExpandedRowKeys={setExpandedRowKeys}
                    handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
                        handleChange(pageNumber, size, sorter);
                    }}
                />
                {isOpenModalFormCopyKR && (
                    <CopyKR
                        krTypeRequest={krBaseSelected?.krType}
                        isOpen={isOpenModalFormCopyKR}
                        idKrBaseSelected={krBaseSelected?.id}
                        planPeriodIdSelected={filters?.planPeriodId}
                        planPeriodType={filters?.planPeriodType}
                        idObjective={idObjectiveSelected}
                        onClose={handleCloseModalCreateKrNextPlanPeriod}
                    />
                )}
            </Container>
        </Modal>
    );
}

export default CopyKRComponent;